"use strict";
const createSearchStringQuery = searchString => {
    const complaintNumber = Number.parseInt(searchString, 10);
    if (!complaintNumber)
        return {};
    return {
        or: [
            {
                complaintNumber: {
                    eq: complaintNumber,
                },
            },
        ],
    };
};
module.exports = createSearchStringQuery;
